import { youtubeIframeEmbedSrc } from '../lib/media-url';
import { attachFcMediaStartOverlay } from './fc-media-start-overlay';

/**
 * Empty containers with data-fc-youtube-id (e.g. from CMS) → iframe embed.
 * Prefer initFcMediaEmbedUrls when a full URL is available.
 */
export function initFcYoutubeEmbeds(root: ParentNode = document): void {
  root.querySelectorAll<HTMLElement>('[data-fc-youtube-id]').forEach((container) => {
    if (container.querySelector('iframe')) {
      return;
    }
    const id = container.dataset.fcYoutubeId?.trim();
    if (!id) {
      return;
    }

    const iframe = document.createElement('iframe');
    iframe.className = 'fc-youtube__iframe';
    iframe.src = youtubeIframeEmbedSrc(id);
    iframe.setAttribute('loading', 'lazy');
    iframe.setAttribute(
      'title',
      container.dataset.fcMediaEmbedIframeTitle?.trim() || 'YouTube player',
    );
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute(
      'allow',
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share',
    );
    container.appendChild(iframe);
    attachFcMediaStartOverlay(container);
  });
}
